// Shared per-run colour scheme used by both the live map route lines
// (TransportMapPanel) and the right-panel order cards (VehicleCard, New UI
// mode) so a run's colour is visually consistent everywhere.
export const RUN_COLORS = ['#f97316', '#a855f7', '#ec4899', '#3b82f6']; // Orange, Purple, Pink, Blue
export const RUN_COLOR_NAMES = ['Orange', 'Purple', 'Pink', 'Blue'];

// runNumber is 1-indexed (Run 1, Run 2, Run 3, Run 4, cycles after that)
export const getRunColor = (runNumber = 1) => RUN_COLORS[(Math.max(runNumber, 1) - 1) % RUN_COLORS.length];
